import * as React from "react";
import { AlertMessage, AlertType, ButtonType, CustomButton, CustomSubmitButton, Form, HiddenInput, HsaIdInput, Modal, ModalBody, ModalFooter, ModalSize, TextInput } from "soprasteria-ui-library";
import { ClinicApi } from "../../../api/ClinicApi";
import { useAuth } from "../../../App";
import { IClinic } from "../../../models/IClinic";
import { setMessage } from "../../../helpers/MessageHelper";
import { emailAddressRegExp } from "../../../helpers/RegExpHelper";

interface IProps {
    clinic: IClinic | undefined;
    onSubmit: (clinicId: number) => void;
    closeModal: () => void;
}

export const EditClinicModal: React.FunctionComponent<IProps> = ({ clinic, onSubmit, closeModal }) => {
    const auth = useAuth();
    const api = new ClinicApi(auth);
    const abortController = new AbortController();
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        document.getElementById("open-edit-clinic-modal")?.click();

        return () => {
            abortController.abort();
        }
    }, [clinic]);

    const onFormSubmit = (data: IClinic) => {
        setIsLoading(true);
        data.clinicId = parseInt(data.clinicId.toString());
            api.updateClinic(data, () => {
                onSubmit(clinic!.clinicId!);
            }, (message: string) => {
                const newMessage = setMessage(message, errorMessage);
                setErrorMessage(newMessage);
            }, () => setIsLoading(false));
    }

    return (
        <Modal id="edit-clinic-modal" modalSize={ModalSize.large} header={clinic?.clinicId ? "Redigera mottagning" : "Lägg till mottagning"}>
            <Form onSubmit={onFormSubmit}>
                <ModalBody>
                    <AlertMessage alertType={AlertType.danger} duration={5000} >{errorMessage}</AlertMessage>
                    <div className="row">
                        <div className="col-12">
                            <HiddenInput name="clinicId" value={clinic?.clinicId ? clinic.clinicId.toString() : "0"} />
                            <TextInput labelCol={5} inputCol={7} label="E-postadress" name="visitingAddressEmailAddress" maxLength={50} pattern={emailAddressRegExp()} patternValidationMessage="Ogiltigt format på e-postadress" defaultValue={clinic?.visitingAddressEmailAddress} required inlineLabel />
                            <TextInput labelCol={5} inputCol={7} label="Telefonnummer" name="visitingAddressPhoneNumber" defaultValue={clinic?.visitingAddressPhoneNumber} inlineLabel />
                            <TextInput labelCol={5} inputCol={7} label="Alt. telefonnummer" name="visitingAddressAlternativePhoneNumber" defaultValue={clinic?.visitingAddressAlternativePhoneNumber} inlineLabel />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton buttonType={ButtonType.general} id="close-edit-clinic-modal" data-dismiss="modal" onClick={() => closeModal()} buttonText="Avbryt" />
                        <CustomSubmitButton isLoading={isLoading}>Spara</CustomSubmitButton>
                        <input type="hidden" data-toggle="modal" id="open-edit-clinic-modal" data-target="#edit-clinic-modal" />
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    );
}